import React from "react";

// Components
import Footer from "../components/Footer";
import Breadcrumbs from "../components/Breadcrumbs";
import Navbar from "../components/Modal/Navbar";

function Reports() {
  return (
    <div className="Reports">
      <div className="wrapper">
        <Navbar />
        <div className="main-panel">
          <div className="container-fluid">
            <div className="page-inner py-4">
              {/* Page Header */}
              <div className="d-flex align-items-center justify-content-between mb-4">
                <Breadcrumbs page="Reports" items={[]} />
              </div>

              {/* Cards Section */}
              <div className="row row-cols-1 row-cols-md-2 row-cols-lg-2 g-4">
                {/* Card Template */}
                {[
                  {
                    title: "1. รายงานยอดซื้อ / ขายประจำวัน",
                    icon: "fas fa-file",
                    bgColor: "bg-info",
                    link: "/sales-report",
                  },
                  {
                    title: "2.1 รายงาน Inventory Movement (แยกตามแผนก/คลัง)",
                    icon: "fas fa-file",
                    bgColor: "bg-info",
                    link: "/inventory-movement-report",
                  },
                  {
                    title:
                      "2.2 รายงานสินค้าคงเหลือประจำวัน แยกตามคลัง / แยกตามสินค้า",
                    icon: "fas fa-file",
                    bgColor: "bg-info",
                    link: "/stock-balance-report",
                  },
                  {
                    title: "3. รายงานยืมลังประจำวัน",
                    icon: "fas fa-file",
                    bgColor: "bg-info",
                    link: "/loan-crate-report",
                  },
                  {
                    title: "4. รายงานมัดจำประจำวัน",
                    icon: "fas fa-file",
                    bgColor: "bg-info",
                    link: "/deposit-report",
                  },
                  {
                    title: "5. รายงานลูกค้ายืมลัง แล้วไม่สั่งเกินสัปดาห์",
                    icon: "fas fa-file",
                    bgColor: "bg-info",
                    link: "/overdue-loan-crate-report",
                  },
                  {
                    title: "6.1 รายงานลูกหนี้ รายวัน",
                    icon: "fas fa-file",
                    bgColor: "bg-info",
                    link: "/receivables-report",
                  },
                  {
                    title: "6.2 รายงานเจ้าหนี้ รายวัน",
                    icon: "fas fa-file",
                    bgColor: "bg-info",
                    link: "/payables-report",
                  },
                  {
                    title: "6.3 รายงานนำส่งรายได้",
                    icon: "fas fa-file",
                    bgColor: "bg-info",
                    link: "/vansale-report",
                  },
                ].map((card, index) => (
                  <div className="col" key={index}>
                    <div
                      className="card h-100 border-primary shadow-sm"
                      style={{
                        cursor: "pointer",
                        transition: "transform 0.2s",
                      }}
                      onClick={() => window.location.replace(card.link)}
                      onMouseOver={(e) =>
                        (e.currentTarget.style.transform = "scale(1.05)")
                      }
                      onMouseOut={(e) =>
                        (e.currentTarget.style.transform = "scale(1)")
                      }
                    >
                      <div className="card-body d-flex align-items-center">
                        <div
                          className={`me-3 text-center text-white ${card.bgColor} rounded-circle p-4`}
                        >
                          <i className={`${card.icon} fa-2x`}></i>
                        </div>
                        <div>
                          <p className="card-category text-muted mb-1">
                            {card.title}
                          </p>
                          {/* <h4 className="card-title mb-0">{card.count} รายการ</h4> */}
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default Reports;
